//copied to src by build.sh

export const baseURL = "https://hotelium.t-bit.si";

